import gql from 'graphql-tag';

export const GetAllUsersQuery = gql`
  query GetAllUsers {
    users {
      username
      id
      createdAt
      firstname
      lastname
      email
      phone
      status
    }
  }
`;

export const CreateUserMutation = gql`
  mutation CreateNewUser($input: UserInput!) {
    createUser(input: $input) {
      username
      id
      createdAt
      firstname
      lastname
      email
      phone
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/Users/graphql.js